// API Interceptor to handle token expiration and unauthorized responses
import { logout } from '../services/authService';

/**
 * Checks if a response indicates token expiration or unauthorized access
 * and automatically logs out the user if needed
 */
export const handleApiResponse = async (response: Response): Promise<Response> => {
  // Check for 401 (Unauthorized) or 403 (Forbidden) - typically means token expired
  // AUTO-LOGOUT DISABLED - Commented out
  // if (response.status === 401 || response.status === 403) {
  //   console.warn('⚠️ Token expired or unauthorized access detected. Logging out...');
  //   
  //   // Try to get error message from response
  //   try {
  //     const errorData = await response.clone().json();
  //     console.log('Error details:', errorData);
  //   } catch (e) {
  //     // Response might not be JSON
  //   }
  //   
  //   // Clear auth and redirect to login
  //   logout();
  //   
  //   // Return the response so calling code can handle it if needed
  //   return response;
  // }
  
  return response;
};

/**
 * Wrapper for fetch that automatically handles token expiration
 */
export const fetchWithAuth = async (
  url: string,
  options: RequestInit = {}
): Promise<Response> => {
  const response = await fetch(url, options);
  return handleApiResponse(response);
};

